import './../src-utilities/country.js';
import JustValidate from './../../node_modules/just-validate';
const getInTouch = document.querySelector('#contactusform');
const validate = new JustValidate('#contactusform');
validate
	.addField('#git-fullname', [
		{
			rule: 'required',
		},
		{
			rule: 'minLength',
			value: 2,
		},
		{
			rule: 'customRegexp',
			value: /^(?=\S)([A-Za-z.]+(?:\s+[.A-Za-z]+){1,})$/,
			errorMessage: 'Enter Valid Full Name',
		},
	])
	.addField('#git-company-email', [
		{
			rule: 'required',
		},
		{
			rule: 'email',
		},
		{
			validator: (value) => {
				let emailRegex =
					/^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,7})+$/;
				return emailRegex.test(value);
			},
			errorMessage: 'Please Enter Valid Email Address',
		},
	])
	.addField('#get-in-touch-phonenumber', [
		{
			rule: 'required',
		},
		{
			rule: 'minLength',
			value: 4,
		},
		{
			rule: 'customRegexp',
			value: /^[0-9]+$/,
		},
		{
			rule: 'maxLength',
			value: 15,
		},
		{
			rule: 'number',
		},
	])
	.addField('#companyname', [
		{
			rule: 'required',
		},
		{
			rule: 'minLength',
			value: 2,
		},
	])
	.addField('#lookingfor', [
		{
			rule: 'required',
		},
	])
	.addField('#git-yourmessage', [
		{
			rule: 'required',
		},
		{
			rule: 'maxLength',
			value: 3000,
		},
	])
	.addField('.country-phone-code', [
		{
			rule: 'required',
		},
	]);
let GoogleSendURL =
	'https://script.google.com/macros/s/AKfycbyML8OHUDSwwvY_QcBlZ2uHYN_rQIx_VlWZPLjpxoJ9dB8GQEr6J7U0D8kNzC3-p0nH/exec';
getInTouch.addEventListener('submit', async (event) => {
	event.preventDefault();
	if (validate.isValid == false) {
		return false;
	}
	document.querySelector('.loading-div').classList.add('active');
	let formData = new FormData(event.target);
	let fullName = formData.get('lfirstname').split(' ');
	let firstName, lastName;
	[firstName, ...lastName] = fullName;
	lastName = lastName.join(' ');
	let phoneNumber = formData.get('lphone');
	let phoneCode = formData.get('phonecode');
	let leadSource = 'Website Form - Talk to Consultant';
	formData.set('lfirstname', firstName);
	formData.set('llastname', lastName);
	formData.set('lphone', phoneCode + ' ' + phoneNumber);
	formData.append('lsource', leadSource);
	let myHeaders = new Headers();
	myHeaders.append('Content-Type', 'application/json');
	// Initiate the Sales IQ visitor data
	if (window.$zoho && window.$zoho.salesiq) {
		try {
			$zoho.salesiq.visitor.uniqueid();
			$zoho.salesiq.visitor.name(firstName + ' ' + lastName);
			$zoho.salesiq.visitor.email(formData.get('lemail'));
			console.log('SalesIQ Name/Email set');
		} catch (error) {
			console.warn('SalesIQ Error:', error);
		}
	}
	let raw = JSON.stringify({
		firstName: formData.get('lfirstname'),
		lastName: formData.get('llastname'),
		email: formData.get('lemail'),
		phone: formData.get('lphone'),
		company: formData.get('lcompany'),
		interestedServices: formData.get('interestedservices'),
		description: formData.get('Description'),
		leadSource: formData.get('lsource'),
		websiteVisitURL: window.location.href,
	});
	let requestOptions = {
		method: 'POST',
		headers: myHeaders,
		body: raw,
		redirect: 'follow',
	};
	let googleRequestOptions = {
		method: 'GET',
		redirect: 'follow',
	};
	let request = '?';
	[...formData].forEach(([key, value], index) => {
		request += `${index === 0 ? '' : '&'}${key + '=' + value}`;
	});
	// Request 1: Main Backend
	const backendRequest = fetch(
		'https://us-west1-zoho-crm-scripts.cloudfunctions.net/queueLeadHttp',
		requestOptions,
	);
	// Request 2: Update the Google Sheet Data
	const googleRequest = fetch(GoogleSendURL + request, googleRequestOptions);
	// Waiting until these request get's completed
	try {
		await Promise.allSettled([backendRequest, googleRequest]);
	} catch (e) {
		console.error('API Error', e);
	}
	// Redirect
	window.location.href = 'https://cyntexa.com/success';
});
